import React from 'react';
import { Wine, AlertTriangle, CheckCircle, Clock } from 'lucide-react';
export function EssentialMetrics() {
  return <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-6" data-id="element-26">
      <MetricCard title="Active Wines" value="42" icon={<Wine className="w-5 h-5" data-id="element-28" />} trend="+3 this month" color="text-purple-600" data-id="element-27" />
      <MetricCard title="Pending Labels" value="15" icon={<Clock className="w-5 h-5" data-id="element-30" />} trend="3 urgent" color="text-yellow-600" data-id="element-29" />
      <MetricCard title="Compliance Issues" value="3" icon={<AlertTriangle className="w-5 h-5" data-id="element-32" />} trend="Action needed" color="text-red-600" data-id="element-31" />
      <MetricCard title="Approved Labels" value="156" icon={<CheckCircle className="w-5 h-5" data-id="element-34" />} trend="+12 this week" color="text-purple-600" data-id="element-33" />
    </div>;
}
interface MetricCardProps {
  title: string;
  value: string;
  icon: React.ReactNode;
  trend: string;
  color: string;
}
function MetricCard({
  title,
  value,
  icon,
  trend,
  color
}: MetricCardProps) {
  return <div className="bg-white p-6 rounded-lg border" data-id="element-35">
      <div className="flex justify-between items-start" data-id="element-36">
        <div data-id="element-37">
          <p className="text-sm text-gray-600" data-id="element-38">{title}</p>
          <p className="text-2xl font-semibold mt-1" data-id="element-39">{value}</p>
        </div>
        <div className={color} data-id="element-40">{icon}</div>
      </div>
      <p className={`text-sm mt-2 ${color}`} data-id="element-41">{trend}</p>
    </div>;
}